import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import MapAssetContainer from "site-apps/assets/MapAssetContainer";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";

import AssetBasicComponent from "site-apps/assets/components/AssetBasic";
import useCustomTranslation from "core/customTranslation";
import {translations} from "../translations";
import ConditionalRender from "components/ConditionalRender";

const PreviewIsland = ({showPrev, item}) => {
    const [t] = useTranslation("forms");
    const {t: tC} = useCustomTranslation(translations);

    return (
        <div className={`${showPrev ? "col-md-4 col-12" : "col-md-4 col-12 d-none"}`}>
            <div className="col preview-row" style={{width: "300px", maxWidth: "300px"}}>
                <div className="row">
                    <div className="col-12 p-0">
                        <div className="preview-card" style={{width: "25%"}}>
                            <div className="preview-header">
                                <div className="preview-icon">
                                    <FontAwesomeIcon icon="boxes-stacked" />
                                </div>
                                <div className="preview-title ms-3">
                                    <div>{t("labels.island")}</div>
                                    <div>{item.name}</div>
                                </div>
                            </div>
                            <Tabs defaultActiveKey="data" id="formprevisland" className="mb-3">
                                <Tab eventKey="data" title={tC("tab.data")}>
                                    <div className="preview-item">
                                        <label>{t("common.name")}</label>
                                        <div className="preview-input">{item.name}</div>
                                    </div>
                                    <div className="preview-item">
                                        <label>{t("common.description")}</label>
                                        <div className="preview-input">{item.description}</div>
                                    </div>
                                    <div className="preview-item">
                                        <label>{t("common.full-address")}</label>
                                        <div className="preview-input">{item.full_address}</div>
                                    </div>

                                    <div className="preview-item">
                                        <label>{tC("zone")}</label>
                                        <div className="preview-input">{item.zone_name}</div>
                                    </div>
                                    <div className="preview-item">
                                        <label>{tC("field.long-lat")}</label>
                                        <div className="preview-input">
                                            {item.lat} / {item.lng}
                                        </div>
                                    </div>
                                    <div className="preview-item">
                                        <label>{t("labels.devices")}</label>
                                        <div className="preview-input">{item.counter}</div>
                                    </div>
                                    <ConditionalRender condition={item && item.lat && item.lng}>
                                        <div className="preview-item">
                                            <MapAssetContainer coords={[item.lat, item.lng]} />
                                        </div>
                                    </ConditionalRender>
                                </Tab>
                                <Tab eventKey="containers" title={tC("tab.containers")}>
                                    <div className="preview-item">
                                        <table className="table table-striped">
                                            <tbody>
                                                {item.actives.length ? (
                                                    item.actives.map((_item, index) => (
                                                        <tr key={index} data-idx={index}>
                                                            <td>
                                                                <AssetBasicComponent asset={_item} />
                                                            </td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <></>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PreviewIsland;
